import React from 'react'
import Header from '../Header/Header'

const Contact = () => {
  return (
    <>
      <Header />
      <section className='contact-layout1 tw-pt-28 md:tw-pt-32 lg:tw-pt-36 pb-60'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12 col-md-12 col-lg-7 mb-3'>
              <form
                className='contact-form'
                method='post'
                action='assets/php/contact.php'
                id='contactForm'
              >
                <div className='row'>
                  <div className='col-sm-12'>
                    <h4 className='contact-panel__title'>Skontaktuj się z nami</h4>
                  </div>
                  <div className='col-sm-6 col-md-6 col-lg-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Imię'
                        id='contact-name'
                        name='contact-name'
                        required
                        style={{
                          border: '1px solid #ddd',
                          borderRadius: '5px'
                        }}
                      />
                    </div>
                  </div>
                  <div className='col-sm-6 col-md-6 col-lg-6'>
                    <div className='form-group'>
                      <input
                        type='email'
                        className='form-control'
                        placeholder='Email'
                        id='contact-email'
                        name='contact-email'
                        required
                      />
                    </div>
                  </div>
                  <div className='col-sm-6 col-md-6 col-lg-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Telefon'
                        id='contact-Phone'
                        name='contact-phone'
                        required
                      />
                    </div>
                  </div>
                  <div className='col-sm-6 col-md-6 col-lg-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Strona WWW'
                        id='contact-website'
                        name='contact-website'
                      />
                    </div>
                  </div>
                  <div className='col-12'>
                    <div className='form-group mb-20'>
                      <textarea
                        className='form-control'
                        placeholder='Dodatkowe szczegóły!'
                        id='contact-message'
                        name='contact-message'
                      />
                    </div>
                    <button
                      type='submit'
                      className='btn btn__primary btn__xhight mt-10'
                    >
                      Wyślij Zapytanie
                    </button>
                    <div className='contact-result' />
                  </div>
                </div>
              </form>
            </div>
            <div className='col-sm-12 col-md-12 col-lg-4 offset-lg-1 mb-3'>
              <div
                className='contact-info d-flex flex-column justify-content-between'
              >
                <div className='bg-img'>
                  <img src='assets/images/contact/1.jpg' alt='banner' />
                </div>
                <div>
                  <h4 className='contact-info__title'>
                    450 000 interakcji z klientami!
                  </h4>
                  <p className='contact-info__desc'>
                    Zapewniamy użytkownikom odpowiedni dostęp do próśb, problemów, zmian, umów i rozwiązań z doświadczonymi profesjonalistami.
                  </p>
                  <p className='contact-info__desc'>
                    Jako jeden z największych dostawców usług IT na świecie, jesteśmy gotowi pomóc.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='contact-layout2 pt-0 pb-80'>
        <div className='container'>
          <div className='row'>
            {/* Contact panel #1 */}
            <div className='col-sm-12 col-md-4 col-lg-4'>
              <div className='contact-info-box'>
                <h4 className='contact__info-box-title'>Biuro w Warszawie</h4>
                <ul className='contact__info-list list-unstyled'>
                  <li>
                    Email:
                    <a href='mailto:Kreatlo@7oroof.com'>Kreatlo@7oroof.com</a>
                  </li>
                  <li>Adres: ul. Przykładowa 123, 00-001 Warszawa</li>
                  <li>Telefon: <a href='tel:48226543210'>+48 22 654 32 10</a></li>
                  <li>Godziny pracy: Pon-Pt: 8:00 – 19:00</li>
                </ul>
              </div>
            </div>
            {/* Contact panel #2 */}
            <div className='col-sm-12 col-md-4 col-lg-4'>
              <div className='contact-info-box'>
                <h4 className='contact__info-box-title'>Biuro w Krakowie</h4>
                <ul className='contact__info-list list-unstyled'>
                  <li>
                    Email:
                    <a href='mailto:Kreatlo@7oroof.com'>Kreatlo@7oroof.com</a>
                  </li>
                  <li>Adres: ul. Floriańska 45, 31-019 Kraków</li>
                  <li>Telefon: <a href='tel:48123456789'>+48 12 345 67 89</a></li>
                  <li>Godziny pracy: Pon-Pt: 8:00 – 19:00</li>
                </ul>
              </div>
            </div>
            {/* Contact panel #3 */}
            <div className='col-sm-12 col-md-4 col-lg-4'>
              <div className='contact-info-box'>
                <h4 className='contact__info-box-title'>Biuro w Poznaniu</h4>
                <ul className='contact__info-list list-unstyled'>
                  <li>
                    Email:
                    <a href='mailto:Kreatlo@7oroof.com'>Kreatlo@7oroof.com</a>
                  </li>
                  <li>Adres: ul. Półwiejska 32, 61-888 Poznań</li>
                  <li>Telefon: <a href='tel:48612345678'>+48 61 234 56 78</a></li>
                  <li>Godziny pracy: Pon-Pt: 8:00 – 19:00</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact
